import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-ac-letter-harry-potter-02-the-smallest-bedroom",
  name: `Harry Potter Acceptance Letter\n'The Smallest Bedroom'`,
  nameFormatted: {
    primary: "Harry Potter Acceptance Letter",
    secondary: "'The Smallest Bedroom'",
  },
  origin: `Harry Potter and the Philosopher's Stone`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
